// extracted by mini-css-extract-plugin
module.exports = {"Info":"Current_Info__2rp5G","Item":"Current_Item__3dIAP"};